import { EventTypes } from 'src/components/ui/EventList/viewModel';
import { z } from 'zod';

const common = {
    universeId: z.string().nullable().default(null),
    symbolFilter: z.string().nullable().default(null),
    symbolRetention: z.string().nullable().default('PT0S'),
    columns: z
        .array(
            z.object({
                columnId: z.string(),
                width: z.number().positive().optional(),
                order: z.number(),
                visible: z.boolean(),
                pinned: z.enum(['left', 'right']).optional(),
            }),
        )
        .optional(),
};

// Keep the established workspace field names so existing workspaces round-trip.
export const newsWidgetStateSchema = z.object({
    ...common,
    ideas: z.array(z.string()).default([]),
});
export const eventsWidgetStateSchema = z.object({
    ...common,
    slowIdeaId: z.string().nullable().default(null),
    fastIdeaIds: z.array(z.string()).default([]),
    eventTypes: z.array(z.enum(EventTypes)).default([]),
    displayingCalendar: z.boolean().default(false),
    splitPercentage: z.number().min(0).max(100).default(50),
});
export const filingsWidgetStateSchema = z.object({
    ...common,
    filingTypes: z.array(z.string()).default(['8-K']),
});
export type NewsWidgetState = z.output<typeof newsWidgetStateSchema>;
export type EventsWidgetState = z.output<typeof eventsWidgetStateSchema>;
export type FilingsWidgetState = z.output<typeof filingsWidgetStateSchema>;
